
// SVG Icon: link
export default { id: "terriajs-link" };
export const id = "terriajs-link";
export const name = "link";
